<template>
  <svg
      xmlns:dc="http://purl.org/dc/elements/1.1/"
      xmlns:cc="http://creativecommons.org/ns#"
      xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
      xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
      width="11.816317mm"
      height="19.973776mm"
      viewBox="0 0 11.816317 19.973776"
      version="1.1"
      id="svg1304"
      inkscape:version="0.92.5 (2060ec1f9f, 2020-04-08)"
      sodipodi:docname="gold_medal.svg">
    <defs
        id="defs1298" />
    <sodipodi:namedview
        id="base"
        pagecolor="#ffffff"
        bordercolor="#666666"
        borderopacity="1.0"
        inkscape:pageopacity="0.0"
        inkscape:pageshadow="2"
        inkscape:zoom="0.35"
        inkscape:cx="-239.09852"
        inkscape:cy="-113.68285"
        inkscape:document-units="mm"
        inkscape:current-layer="layer1"
        showgrid="false"
        fit-margin-top="0"
        fit-margin-left="0"
        fit-margin-right="0"
        fit-margin-bottom="0"
        inkscape:window-width="1920"
        inkscape:window-height="1017"
        inkscape:window-x="1912"
        inkscape:window-y="-8"
        inkscape:window-maximized="1" />
    <metadata
        id="metadata1301">
      <rdf:RDF>
        <cc:Work
            rdf:about="">
          <dc:format>image/svg+xml</dc:format>
          <dc:type
              rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
          <dc:title></dc:title>
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <g
        inkscape:label="Layer 1"
        inkscape:groupmode="layer"
        id="layer1"
        transform="translate(-46.252555,-98.780972)">
      <g
          id="g1895">
        <g
            id="g964-1-4-2"
            transform="matrix(0.36971004,0,0,0.36971004,14.067846,61.208653)">
          <g
              id="g979-5-5-5-5"
              transform="matrix(-1.0719887,0,0,1.0719887,148.10993,95.995901)">
            <path
                inkscape:connector-curvature="0"
                id="path974-6-5-1-6"
                d="m 50.082968,5.9638287 -15.23437,-0.200453 3.00679,8.1517193 9.28761,-0.06681 z"
                style="fill:#5599ff;stroke:#666666;stroke-width:1.02188861;stroke-linecap:butt;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" />
            <path
                inkscape:connector-curvature="0"
                id="path970-9-9-5-4"
                d="m 35.650408,30.15172 -7.41673,-16.904798 6.61492,-7.4835463 9.08717,23.2524483 z"
                style="fill:#80b3ff;stroke:#666666;stroke-width:1.02188861;stroke-linecap:butt;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" />
            <path
                inkscape:connector-curvature="0"
                id="path972-9-7-77-3"
                d="m 50.082968,5.9638287 -9.28762,23.6533533 8.15172,0.534538 7.41673,-17.038431 z"
                style="fill:#aaccff;stroke:#666666;stroke-width:1.02188861;stroke-linecap:butt;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" />
          </g>
          <g
              id="g1284-8-4-7"
              transform="translate(192.43406,158.70438)">
            <circle
                r="15.432793"
                cy="-18.912741"
                cx="-89.58036"
                id="path826-8-9-9-8"
                style="opacity:1;vector-effect:none;fill:#fdd309;fill-opacity:1;stroke:#cca325;stroke-width:0.51353562;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;marker:none" />
            <path
                inkscape:connector-curvature="0"
                id="path826-31-9-2-92-2"
                d="m -89.516642,-34.129806 a 15.206922,15.206922 0 0 0 -15.206778,15.207276 15.206922,15.206922 0 0 0 4.53293,10.813204 l 21.450488,-21.531038 a 15.206922,15.206922 0 0 0 -10.77664,-4.489442 z"
                style="opacity:1;vector-effect:none;fill:#ffdf52;fill-opacity:0.99215686;stroke:none;stroke-width:0.50601965;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;marker:none" />
            <circle
                r="12.275723"
                cy="-18.912741"
                cx="-89.58036"
                id="path826-3-5-6-27-4"
                style="opacity:1;vector-effect:none;fill:none;fill-opacity:1;stroke:#cca325;stroke-width:0.40848216;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;marker:none" />
            <path
                sodipodi:nodetypes="cccccccccccccccc"
                inkscape:connector-curvature="0"
                id="path895-3-4-5-1-5-5"
                d="m -90.218592,-27.769115 -2.59374,5.382027 -5.77109,0.71328 -0.19453,0.648437 4.15,3.95546 -0.90781,6.289836 0.71328,0.324219 4.86327,-2.723433 5.25234,2.723433 0.5836,-0.453903 -1.16719,-5.511715 4.34452,-4.344525 -0.12969,-0.71328 -5.51171,-0.778125 -2.69102,-5.511709 z"
                style="opacity:1;vector-effect:none;fill:#cca325;fill-opacity:1;stroke:none;stroke-width:0.40752771;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;marker:none" />
            <path
                inkscape:connector-curvature="0"
                id="path934-0-7-3-5"
                d="m -95.316822,-12.322213 -0.12838,0.887655 0.71364,0.32397 4.86304,-2.723644 5.2522,2.723644 0.58375,-0.453856 -1.16699,-5.511982 4.34449,-4.344492 -0.12988,-0.713134 -3.99545,-0.563686 z"
                style="fill:#febd09;fill-opacity:1;stroke:none;stroke-width:0.25676781px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
            <path
                inkscape:connector-curvature="0"
                id="path895-3-8-0-6-2-2"
                d="m -95.316822,-12.322213 10.33641,-10.375525 -1.51603,-0.214139 -2.69105,-5.511984 h -0.94031 l -2.59375,5.382096 -5.77126,0.713132 -0.19459,0.648438 4.15041,3.955328 z"
                style="fill:#ffca36;fill-opacity:1;stroke:none;stroke-width:0.25676781px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
            <path
                inkscape:connector-curvature="0"
                id="path1023-9-7-3-9"
                d="m -98.333522,-9.955513 c 2.25111,2.204252 5.32512,3.571839 8.72264,3.571839 6.89007,0 12.48054,-5.590466 12.48054,-12.480536 0,-3.414303 -1.37818,-6.504495 -3.60169,-8.758462 l -0.28754,0.289527 c 2.14773,2.178974 3.47931,5.165825 3.47931,8.468935 0,6.669312 -5.40131,12.070618 -12.07062,12.070618 -3.28732,0 -6.25882,-1.320832 -8.43511,-3.450455 z"
                style="color:#000000;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;font-variant-ligatures:normal;font-variant-position:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-alternates:normal;font-feature-settings:normal;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#000000;letter-spacing:normal;word-spacing:normal;text-transform:none;writing-mode:lr-tb;direction:ltr;text-orientation:mixed;dominant-baseline:auto;baseline-shift:baseline;text-anchor:start;white-space:normal;shape-padding:0;clip-rule:nonzero;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:#000000;solid-opacity:1;vector-effect:none;fill:#fff7cf;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:0.40848216;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;marker:none;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto;enable-background:accumulate" />
          </g>
        </g>
        <circle
            r="5.7056584"
            cy="112.84659"
            cx="52.160713"
            id="path826-8-9-9-4-1"
            style="opacity:1;vector-effect:none;fill:none;fill-opacity:1;stroke:#666666;stroke-width:0.405;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;marker:none" />
      </g>
    </g>
  </svg>


</template>

<script>
export default {
  name: "MedalBronze"
}
</script>

<style scoped>

</style>